'use strict';

angular.module('ClinicApp').directive('userPassword', function(UserService) {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_user-password.html',
    link: function($scope) {
      $scope.editMode = false;
      $scope.saving = false;
      $scope.password = {
        current: null,
        new: null,
        confirm: null,
      };

      $scope.changePassword = function() {
        $scope.saving = true;
        return UserService.updateCurrentUserPassword($scope.password.current, $scope.password.new)
          .then(() => {
            $scope.password = {};
            $scope.editMode = false;
          })
          .finally(() => {
            $scope.saving = false;
          });
      };
    },
  };
});
